import React, { useState } from 'react';
import { TruckIcon, TagIcon, ChevronRightIcon, AwardIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
interface OrderSummaryProps {
  subtotal: number;
  discount: number;
  tax: number;
  total: number;
  itemCount: number;
  onOpenCoupons?: () => void;
}
export function OrderSummary({
  subtotal,
  discount,
  tax,
  total,
  itemCount,
  onOpenCoupons
}: OrderSummaryProps) {
  const navigate = useNavigate();
  const [showCoupons, setShowCoupons] = useState(false);
  // Calculate estimated loyalty points (e.g., 1 point per 10 SAR)
  const estimatedPoints = Math.floor(total / 10);
  const paymentMethods = ['https://uploadthingy.s3.us-west-1.amazonaws.com/34T2tXtbEwvap5cxibG8Zw/image.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/tUoQjWm1v91aJ1XmKpKUWr/image.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/vxtujNwTU2t3ZDV59PkjmC/image.png'];
  const installmentOptions = [{
    provider: 'Tamara',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/34T2tXtbEwvap5cxibG8Zw/image.png',
    installments: 4,
    amount: (total / 4).toFixed(2)
  }, {
    provider: 'Tabby',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tUoQjWm1v91aJ1XmKpKUWr/image.png',
    installments: 4,
    amount: (total / 4).toFixed(2)
  }];
  return <div className="sticky top-24" data-id="element-1925" data-mp="2hegph0y3pf17">
      <div className="bg-white rounded-lg shadow-sm p-4 md:p-6" data-id="element-1926" data-mp="3ezurzn6e561r">
        <h2 className="text-xl font-bold mb-6" data-id="element-1927" data-mp="3f277ltoof4bn">Checkout</h2>
        {/* Order Summary */}
        <div className="space-y-3 mb-6" data-id="element-1928" data-mp="3a1t9p4gsharc">
          <div className="flex justify-between text-sm" data-id="element-1929" data-mp="359rrz30uqrtx">
            <span className="text-gray-600" data-id="element-1930" data-mp="358gluwjxp7zn">Subtotal</span>
            <span className="font-medium" data-id="element-1931" data-mp="30bzxq2cqitmk">{subtotal.toFixed(2)} SAR</span>
          </div>
          <div className="flex justify-between text-sm" data-id="element-1932" data-mp="1lq0gua13e0w">
            <span className="text-gray-600" data-id="element-1933" data-mp="1navsm4630zt">Discount</span>
            <span className="font-medium text-green-600" data-id="element-1934" data-mp="3syug8tpzrixe">
              -{discount.toFixed(2)} SAR
            </span>
          </div>
          <div className="flex justify-between text-sm" data-id="element-1935" data-mp="1r4g9gdwzs41g">
            <span className="text-gray-600" data-id="element-1936" data-mp="1v2vs65m1iq92">Tax</span>
            <span className="font-medium" data-id="element-1937" data-mp="1v5rq3txw1exi">{tax.toFixed(2)} SAR</span>
          </div>
          <div className="pt-3 border-t border-gray-200" data-id="element-1938" data-mp="1hafxpt77g0jr">
            <div className="flex justify-between items-center" data-id="element-1939" data-mp="1malgskzeseq8">
              <span className="font-medium" data-id="element-1940" data-mp="17eclfuin2lj3">Total (Include Vat)</span>
              <span className="text-xl font-bold text-[#1E2B55]" data-id="element-1941" data-mp="17d1k01co1pv5">
                {total.toFixed(2)} SAR
              </span>
            </div>
          </div>
        </div>

        {/* Loyalty Points Preview */}
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4 flex items-center gap-3" data-id="element-1942" data-mp="yg0x5z58vztt">
          <div className="w-8 h-8 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1943" data-mp="2srpfmbaoqkiy">
            <AwardIcon className="w-4 h-4 text-yellow-600" data-id="element-1944" data-mp="2xqiizaw9cv5e" />
          </div>
          <div data-id="element-1945" data-mp="2xopikdc8n75u">
            <p className="text-sm font-medium text-yellow-800" data-id="element-1946" data-mp="37uql6a5sj2wy">
              Earn {estimatedPoints} Loyalty Points
            </p>
            <p className="text-xs text-yellow-600" data-id="element-1947" data-mp="32wp0xlwmoxjw">With this purchase</p>
          </div>
        </div>

        {/* Complete Purchase Button */}
        <button onClick={() => navigate('/checkout')} className="w-full bg-[#1E2B55] text-white py-3 rounded-lg font-bold hover:bg-[#162041] transition-colors mb-4 shadow-md hover:shadow-lg" data-id="element-1948" data-mp="3gp5a74g4hrt9">
          Proceed to Checkout
        </button>

        {/* Coupons Section */}
        <div className="border border-gray-200 rounded-lg p-4 mb-4" data-id="element-1949" data-mp="3lo81zn73e1ja">
          <button onClick={() => onOpenCoupons?.()} className="flex items-center justify-between w-full group" data-id="element-1950" data-mp="3f7mc58m66al">
            <div className="flex items-center gap-2" data-id="element-1951" data-mp="257vsongk19ul">
              <TagIcon className="w-5 h-5 text-[#1E2B55]" data-id="element-1952" data-mp="258dus0pweiaf" />
              <div className="text-left" data-id="element-1953" data-mp="216sahub1b1q7">
                <p className="font-medium group-hover:text-[#1E2B55] transition-colors" data-id="element-1954" data-mp="217v1s3c9r66n">
                  Coupons
                </p>
                <p className="text-xs text-gray-500" data-id="element-1955" data-mp="27miq59tydjxu">Save More</p>
              </div>
            </div>
            <span className="text-sm font-medium text-[#1E2B55] hover:underline" data-id="element-1956" data-mp="2bo4839lcgoew">
              View & Apply
            </span>
          </button>
        </div>
        {/* Installment Options */}
        <div className="space-y-3" data-id="element-1957" data-mp="1jwy6eopz6ini">
          {installmentOptions.map((option, index) => <div key={index} className="border border-gray-200 rounded-lg p-3 hover:border-[#1E2B55] transition-colors cursor-pointer" data-id="element-1958" data-mp="1jv4xf2rw3mcc" data-mpi={index}>
              <div className="flex items-center gap-3" data-id="element-1959" data-mp="1swbhtmxnthav">
                <img src={option.logo} alt={option.provider} className="h-8 object-contain" data-id="element-1960" data-mp="1xomf0i10mozq" />
                <div className="flex-1" data-id="element-1961" data-mp="1074g6f2wsble">
                  <p className="text-sm font-medium" data-id="element-1962" data-mp="1570crt9a10qx">
                    Divide It Into {option.installments} Installments Of{' '}
                    {option.amount} SAR
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-1963" data-mp="sp6douj5a0ro">
                    Interest-Free, Sharia-Compliant
                  </p>
                </div>
                <button className="text-xs text-[#1E2B55] hover:underline" data-id="element-1964" data-mp="nsfuvzfygr2k">
                  Learn More
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}